import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import useStore from '../store';
import 'swiper/css/swiper.css';
import NeedAppointment from '../sub-components/need-appointment.vue';
export default defineComponent({
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    NeedAppointment: NeedAppointment
  },
  setup: function setup(props, ctx) {
    var store = useStore();
    var swiperOptions = {
      speed: 500,
      slidesPerView: 'auto',
      initialSlide: store.activeVenueIndex,
      centeredSlides: true,
      observer: true,
      observeParents: true
    };
    var mySwiper = ref(null);
    /** swiper实例，可以根据这个获取到当前的index，就是下面的actievIndex */

    var swiperComponentinstance = computed(function () {
      var _mySwiper$value;

      return (_mySwiper$value = mySwiper.value) === null || _mySwiper$value === void 0 ? void 0 : _mySwiper$value.$swiper;
    });
    var activeIndex = computed(function () {
      return store.activeVenueIndex;
    });
    watch(function () {
      return activeIndex.value;
    }, function () {
      var _swiperComponentinsta;

      if (activeIndex.value !== ((_swiperComponentinsta = swiperComponentinstance.value) === null || _swiperComponentinsta === void 0 ? void 0 : _swiperComponentinsta.activeIndex)) {
        var _swiperComponentinsta2;

        (_swiperComponentinsta2 = swiperComponentinstance.value) === null || _swiperComponentinsta2 === void 0 ? void 0 : _swiperComponentinsta2.slideTo(activeIndex.value);
      }
    });

    var updateIndex = function updateIndex(index) {
      store.changeActiveVenueIndex(index);
    };

    var handleCardChange = function handleCardChange() {
      // 需要计时器，低端机太卡了，得把逻辑滞后,假如
      setTimeout(function () {
        var _swiperComponentinsta3;

        updateIndex(((_swiperComponentinsta3 = swiperComponentinstance.value) === null || _swiperComponentinsta3 === void 0 ? void 0 : _swiperComponentinsta3.activeIndex) || 0);
      }, 0);
    }; // const { handleTouchStart, handleTouchEnd, handleTouchMove } =
    //     useToScrollHook();


    return {
      mySwiper: mySwiper,
      handleCardChange: handleCardChange,
      store: store,
      swiperOptions: swiperOptions
    };
  }
});